<template>
  <div> 
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0  >
      <v-layout >
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular indeterminate :size="50" 
            color="grey" 
            :width="7" 
            v-if="loading"></v-progress-circular>
        </v-flex>
      </v-layout>    
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2 >
       
          <h2>About the loop</h2>
          <p>The Loop is an initiative of the City of Hobart, through the Creative Hobart Strategy, developed in
partnership with the University of Tasmania (UTAS).
This large-scale outdoor public screen, located in the courtyard of UTAS student accommodation
at 157 Elizabeth Street, screens a daily cultural program throughout the year.</p>
          <h2>Mission</h2>
          <p>The Loop is a detour into digital culture. An oasis of art in the city. A place to share, experiment
and discover. Showcasing the richness and diversity of Tasmania’s creative scene it is designed
to enrich the daily civic life of Hobart’s CBD by offering encounters that delight, inspire and
provoke.</p>
<p>
As a dedicated arts platform the Loop strives to foster and present work that is innovative,
collaborative, inclusive, expressive, reflective and highly creative. As such, it will not display
advertising or other commercially focused content.</p>
<p>

The Loop has capacity to accommodate interactivity and live-streaming with a vision to expand
its technical / conceptual parameters as the project evolves..</p>

<p>
Community members, artists, curators and organisations are encouraged to contribute content
for consideration. Please visit the <v-btn :to="'/participate'">Participate</v-btn> page for more information.</p><p>
Sometimes the audience will become the artist. Sometimes the City itself will become “art”.</p>
        
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
 export default {
   
   data () {
     return {
       glitches:null,
       glitchCount:20,
       glitchTop:200
     }
   },
   mounted(){
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
   },
   computed: {
     loading () {
       return this.$store.getters.loading
     },
    
    },
   methods: {
     glitch(){

        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          
          return
         
       }
        
       
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
     
   }
 }
</script>

<style scoped>
.glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:200px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}

</style>



// WEBPACK FOOTER //
// src/components/About.vue